import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper';
import css from './index.module.scss';
import EFPic from '@/components/UI/EFPic';
import EFRightArrow from '@/components/UI/svg/Icons/EFRightArrow';
import { EfRightOutlined } from '@/element/icons';
import { useGlobal } from '@/utils/useGlobal';
// import { TweenMax } from 'gsap';

export default function B() {
    const { useLang, useEffect, useState, Link } = useGlobal();
    const { t } = useLang('csr');
    const data = [
        { icon: ['/img/csr/h5/government_building.webp', '/img/csr/h5/government_building.png'], region: t('secB_list1_region'), desc: t('secB_list1_desc') },
        {
            icon: ['/img/csr/h5/2_2.webp', '/img/csr/h5/2_2.jpg'],
            region: t('secB_list2_region'),
            desc: t('secB_list2_desc'),
            link: { text: t('secB_list3_link'), href: 'https://www.city.tottori.lg.jp/www/contents/1602489863036/index.html' },
        },
        {
            icon: ['/img/csr/h5/2_3.webp', '/img/csr/h5/2_3.jpg'],
            region: t('secB_list3_region'),
            desc: t('secB_list3_desc'),
        },
        { icon: ['/img/csr/h5/government_building.webp', '/img/csr/h5/government_building.png'], region: t('secB_list4_region'), desc: t('secB_list4_desc') },
    ];
    const donateData = [
        {
            dTitle: t('secB_dItem1_title'),
            dLists: [
                t('secB_dItem1_list1'),
                t('secB_dItem1_list2'),
                t('secB_dItem1_list3'),
                t('secB_dItem1_list4'),
                t('secB_dItem1_list5'),
                t('secB_dItem1_list6'),
                t('secB_dItem1_list7'),
                t('secB_dItem1_list8'),
                t('secB_dItem1_list9'),
                t('secB_dItem1_list10'),
                t('secB_dItem1_list11'),
                t('secB_dItem1_list12'),
                t('secB_dItem1_list13'),
            ],
        },
        {
            dTitle: t('secB_dItem2_title'),
            dLists: [
                t('secB_dItem2_list1'),
                t('secB_dItem2_list2'),
                t('secB_dItem2_list3'),
                t('secB_dItem2_list4'),
                t('secB_dItem2_list5'),
                t('secB_dItem2_list6'),
            ],
            dImg: ['/img/csr/h5/2_donate.webp', '/img/csr/h5/2_donate.jpg'],
        },
    ];
    const [winW, setWinW] = useState(375);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setWinW(window.innerWidth);
        }
    }, []);
    // 触屏拖拽mobile
    let startX = 0,
        flag = false;
    const touchStart = (e: any) => {
        startX = e.targetTouches[0].clientX;
        flag = true;
    };
    const touchMove = (e: any) => {
        const moveX = e.targetTouches[0].clientX;
        if (flag) {
            if (moveX < startX && active < data?.length - 1) {
                e.currentTarget.style.transition = '0.4s left cubic-bezier(0.20, 0.00, 0.32, 1.00)';
                e.currentTarget.style.left = `${-(1 + active) * 3 + (active === data?.length - 2 ? 0.35 : 0)}rem`; // 3 => 2.8width + 0.2gap: 最后一个跟右侧边距计算
                setActive(active + 1);
                flag = false;
            }
            if (moveX > startX && active > 0) {
                e.currentTarget.style.transition = '0.4s left cubic-bezier(0.20, 0.00, 0.32, 1.00)';
                e.currentTarget.style.left = `${-(active - 1) * 3 + (active === data?.length - 1 ? 0.35 : 0)}rem`;
                setActive(active - 1);
                flag = false;
            }
        }
    };

    const [showDonate, setShowDonate] = useState(0);
    const [active, setActive] = useState(0);

    const toggleDonate = () => {
        if (showDonate === 1) {
            // 交互式动效(js动画): 「寄贈品について」の開閉動作アニメ
            const dSwiperEl = document.querySelector('.csr_h5_B .dSwiperLists') as HTMLElement;
            dSwiperEl.animate(
                [
                    { transform: `translate3d(0, 0, 0)`, opacity: 1 },
                    { transform: `translate3d(0, 100px, 0)`, opacity: 0 },
                ],
                {
                    duration: 600,
                    delay: 0,
                    fill: 'forwards',
                    easing: 'ease-in-out',
                    iterations: 1,
                },
            );
            const swiperEl = document.querySelector('.csr_h5_B') as HTMLDivElement;
            window.scrollTo({
                top: swiperEl?.offsetTop,
                behavior: 'smooth',
            });
            setTimeout(() => {
                setShowDonate(-1);
            }, 600);
        } else {
            setShowDonate(1);
        }
    };

    useEffect(() => {
        if (showDonate === 1) {
            const donateBoxEl = document.querySelector('.donate') as HTMLDivElement;
            // 交互式动效(js动画): 「寄贈品について」の開閉動作アニメ
            const dSwiperEl = document.querySelector('.csr_h5_B .dSwiperLists') as HTMLElement;
            dSwiperEl.animate(
                [
                    { transform: `translate3d(0, 100px, 0)`, opacity: 0 },
                    { transform: `translate3d(0, 0, 0)`, opacity: 1 },
                ],
                {
                    duration: 600,
                    delay: 0,
                    fill: 'forwards',
                    easing: 'ease-in-out',
                    iterations: 1,
                },
            );
            window.scrollTo({
                top: donateBoxEl?.offsetTop - 40,
                behavior: 'smooth',
            });
        }
    }, [showDonate]);

    const letters: [string] = t('secB_title').split('');

    let controller: any;
    useEffect(() => {
        controller = new ScrollMagic.Controller();
    }, []);

    useEffect(() => {
        // const layoutH = typeof window !== 'undefined' ? window.innerHeight : 750;
        // title文字动效： 与A中的staggerFromTo同效，但css性能更优
        //　CSS動画：性能がよりよい
        new ScrollMagic.Scene({
            triggerElement: '.csr_h5_B', // 触发元素
            triggerHook: 1, // 1: 进入 0: 离开 0.5 中间
            offset: 220, // 触发时机偏移量: 文字进入视窗1/4时
        })
            .setClassToggle('.csr_h5_B .innerBox', 'enter')
            .addTo(controller);

        // // 轮播的动效
        // new ScrollMagic.Scene({
        //     triggerElement: '.csr_h5_B .swiper1', // 触发元素
        //     triggerHook: 1, // 1: 进入 0: 离开 0.5 中间
        //     offset: 200, // 偏移
        //     duration: 320, // 动画滑动距离
        // })
        //     .setTween(TweenMax.to('.csr_h5_B .swiperLists', 0.5, { top: 0, opacity: 1 }))
        //     .addTo(controller);
    }, []);

    return (
        <div className={`csr_h5_B ${css.csr_h5_B}`}>
            <div className="innerBox">
                <p className="title">
                    {letters?.map((letter: any, k: number) => (
                        <span className={`letter_b letter_${k}`} key={k}>
                            {letter}
                        </span>
                    ))}
                </p>
                <div className="swiper1">
                    <ul className="swiperLists" onTouchMove={touchMove} onTouchStart={touchStart}>
                        {data?.map((list: any, k: number) => (
                            <li className="swiperList" key={k}>
                                <div className="icon">
                                    <EFPic src={list?.icon} alt={list?.desc} aria-label={list?.desc} />
                                </div>
                                <p className="region">{list?.region}</p>
                                <p className="desc">{list?.desc}</p>
                                {list?.link && (
                                    <Link className="linkBox" href={list?.link?.href || '/'}>
                                        <div className="linkText">{list?.link?.text}</div>
                                        <div className="linkIcon">
                                            <EFRightArrow stroke={'#03060b'} />
                                        </div>
                                    </Link>
                                )}
                            </li>
                        ))}
                    </ul>
                </div>
                <div className={`donate ${showDonate === 1 ? 'open' : 'close'}`}>
                    <div className="dTitleBox" onClick={toggleDonate}>
                        <div className="dTitle">{t('secB_dTitle')}</div>
                        <div className="dArrow">
                            <EfRightOutlined />
                        </div>
                    </div>
                    {showDonate === 1 && (
                        <div className="dBoxSwiper">
                            <Swiper
                                className="dSwiperLists"
                                modules={[Autoplay]}
                                // autoplay={{
                                //     delay: 4000,
                                //     disableOnInteraction: false,
                                // }}
                                loop
                                initialSlide={0}
                                preloadImages={false}
                                lazy={true}
                                centeredSlides={true}
                                spaceBetween={(winW / 375) * 30}
                                slidesPerView={'auto'}
                                grabCursor={true}
                                navigation={true}
                                // onSwiper={(swiper: any) => setSwiper(swiper)}
                                onSlideChange={(swiper: any) => setActive(swiper?.activeIndex % donateData.length)}
                            >
                                {donateData?.map((list: any, k: number) => (
                                    <SwiperSlide key={k} className="dSwiperList">
                                        <p className="dItemTitle">{list?.dTitle}</p>
                                        {list?.dLists?.map((item: any, m: number) => (
                                            <ol className="dSubItem" key={m}>
                                                <span className="dot">・</span>
                                                {item}
                                            </ol>
                                        ))}
                                        {list?.dImg && (
                                            <div className="dPic">
                                                <EFPic src={list?.dImg} alt={list?.dTitle} aria-label={list?.dTitle} />
                                            </div>
                                        )}
                                    </SwiperSlide>
                                ))}
                            </Swiper>
                            <div className="pagination">
                                {donateData?.map((_item: any, k: number) => (
                                    <li className={`pageItem ${active == k ? 'active' : ''}`} key={k}></li>
                                ))}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
